module.exports = __webpack_public_path__ + "static/media/Goodnest_ios_3_preview.3c0880d1.jpg";